import React from 'react'
import classNames from 'classnames'
import { includes, map, isEmpty } from 'lodash'

import { ReactComponent as IconChevron } from '../../assets/icons/IconChevron.svg'

const DropdownMenu = ({
  options = [],
  className,
  input,
  defaultValue,
  value,
  label,
  handleChange = () => {},
  includeEmpty = false
}) => {

  let emptyOption = null
  if (includeEmpty) emptyOption = <option key='none' value={null}></option>

  const isValueInOptions = includes(map(options, option => option.value), value)
  const checkedValue = isValueInOptions ? value : ''

  return (
    <div className={classNames('dropdown', className, {
      '-selected': !isEmpty(checkedValue) || !isEmpty(defaultValue),
    })}>
      <select
        value={value}
        defaultValue={defaultValue}
        onChange={handleChange}
        className={classNames('dropdown__select')}
        {...input}
      >
        {emptyOption}
        {options.map((option, idx) => (
          <option key={idx} value={option.value}>{option.displayName}</option>
        ))}
      </select>
      <span className="dropdown__arrow">
        <IconChevron className="dropdown__arrow-icon" />
      </span>
      {label && <span className="dropdown__label">{label}</span>}
    </div>
  )
}

export default DropdownMenu
